/**
 * Axios Interceptors Configuration
 *
 * Configures axios interceptors to track API activity for inactivity monitoring
 */

import axios from 'axios'

import {getInactivityTracker} from './inactivity-tracker'

/**
 * Setup axios interceptors to track API requests as user activity
 */
export function setupAxiosInterceptors(): void {
  // Request interceptor - reset timer on outgoing requests
  axios.interceptors.request.use(
    config => {
      const tracker = getInactivityTracker()
      if (tracker) {
        tracker.resetTimer()
      }
      return config
    },
    error => {
      // Still count request errors as activity (user initiated the action)
      const tracker = getInactivityTracker()
      if (tracker) {
        tracker.resetTimer()
      }
      return Promise.reject(error)
    },
  )

  // Response interceptor - reset timer on successful responses
  axios.interceptors.response.use(
    response => {
      const tracker = getInactivityTracker()
      if (tracker) {
        tracker.resetTimer()
      }
      return response
    },
    error => {
      // Still count failed requests as activity
      const tracker = getInactivityTracker()
      if (tracker) {
        tracker.resetTimer()
      }
      return Promise.reject(error)
    },
  )
}
